import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios, {
  fileAxios8251,
  axios8251,
  unAuthGenericAxios,
  axiosBuzzOne,
} from '../../../axios';
import { moduleName } from '../moduleInfo';
import {
  getSchoolClassRoute,
  getSchoolNamesRoute,
  sendMailRoute,
  uploadPhotoRoute,
} from '../utils/apiRoutes';

export const getSchoolNamesAsync = createAsyncThunk(
  `${moduleName}/getSchoolNames`,
  async (payload) => {
    const response = await axios({
      method: 'GET',
      url: getSchoolNamesRoute(payload.userId),
    });
    const data = response.data;
    return data;
  }
);

export const getSchoolClassesAsync = createAsyncThunk(
  `${moduleName}/getSchoolClasses`,
  async () => {
    const response = await axios8251({
      method: 'GET',
      url: getSchoolClassRoute(),
    });
    const data = response.data;
    return data;
  }
);

export const uploadFileAsync = createAsyncThunk(
  `${moduleName}/uploadFile`,
  async (payload) => {
    if (payload.file) {
      const data = new FormData();
      data.append('document', payload.file);
      const localAxios = payload.authToken
        ? unAuthGenericAxios({
            authToken: payload.authToken,
            contentType: 'multipart/form-data',
          })
        : fileAxios8251;
      const response = await localAxios({
        method: 'POST',
        url: uploadPhotoRoute(),
        data,
      });
      return response.data;
    } else if (payload.files) {
      // const data = new FormData();
      // data.append('document', payload.file);
      const localAxios = payload.authToken
        ? unAuthGenericAxios({
            authToken: payload.authToken,
            contentType: 'multipart/form-data',
          })
        : fileAxios8251;
      const response = await localAxios({
        method: 'POST',
        url: uploadPhotoRoute(),
        data: payload.files,
      });
      return response.data;
    }
    throw new Error('No file');
  }
);

export const sendMessageAsync = createAsyncThunk(
  `${moduleName}/sendMessageAsync`,
  async (payload) => {
    const response = await axios({
      method: 'POST',
      url: sendMailRoute(),
      data: payload,
    });
    const data = response.data;
    return data;
  }
);

// This one is for schoolweb backend
export const uploadFileSchoolWebAsync = createAsyncThunk(
  `${moduleName}/uploadFileSchoolWebAsync`,
  async (payload, { rejectWithValue }) => {
    try {
      if (payload.file) {
        const data = new FormData();
        data.append('document', payload.file);
        const localAxios = payload.authToken
          ? axiosBuzzOne({
              authToken: payload.authToken,
              contentType: 'multipart/form-data',
            })
          : axiosBuzzOne;
        const response = await localAxios({
          method: 'POST',
          url: uploadPhotoRoute(),
          data,
        });
        return response.data;
      } else if (payload.files) {
        const localAxios = payload.authToken
          ? axiosBuzzOne({
              authToken: payload.authToken,
              contentType: 'multipart/form-data',
            })
          : axiosBuzzOne;
        const response = await localAxios({
          method: 'POST',
          url: uploadPhotoRoute(),
          data: payload.files,
        });
        return response.data;
      }
      throw new Error('No file');
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const commonStoreSlice = createSlice({
  name: `${moduleName}/main`,
  initialState: {
    loading: false,
    schools: [],
    classes: [],
    message: null,
  },
  reducers: {},
  extraReducers: {
    [getSchoolNamesAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.schools = action.payload.schools;
    },
    [getSchoolNamesAsync.pending]: (state) => {
      state.loading = false;
    },
    [getSchoolNamesAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getSchoolClassesAsync.pending]: (state) => {
      state.loading = true;
    },
    [getSchoolClassesAsync.fulfilled]: (state, action) => {
      state.classes = action.payload.data;
      state.loading = false;
    },
    [getSchoolClassesAsync.rejected]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [uploadFileAsync.fulfilled]: (state) => {
      state.loading = false;
    },
    [uploadFileAsync.pending]: (state) => {
      state.loading = true;
    },
    [uploadFileAsync.rejected]: (state) => {
      state.loading = false;
    },
    [sendMessageAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [sendMessageAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action.payload;
    },
    [sendMessageAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    [uploadFileSchoolWebAsync.fulfilled]: (state) => {
      state.loading = false;
    },
    [uploadFileSchoolWebAsync.pending]: (state) => {
      state.loading = true;
    },
    [uploadFileSchoolWebAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export default commonStoreSlice.reducer;
